export default "__VITE_ASSET__89f8352e__"